import { colors } from '@/constants/colors';
import IconsLib from '@/utils/IconsLib';
import React from 'react';
import styled, { keyframes } from 'styled-components';

interface Props {
   show: boolean;
   title: string;
   handleClose: () => void;
   children: React.ReactNode;
}

const _Placeholder = ({ show, title, handleClose, children }: Props) => {
   return (
      <Wrapper $show={show ? 'true' : 'false'}>
         <MobileHandle onClick={handleClose} />
         <HeadingWrapper>
            <Heading>{title}</Heading>
            <CloseBtn onClick={handleClose}>
               <IconsLib icon="close-line" size="20px" color={colors.GRAY5} />
            </CloseBtn>
         </HeadingWrapper>
         <ScrollBody>{children}</ScrollBody>
      </Wrapper>
   );
};

const Wrapper = styled.div<{
   $show: string;
}>`
   background-color: var(--app-surface);
   visibility: ${({ $show }) => ($show === 'true' ? 'visible' : 'hidden')};
   opacity: ${({ $show }) => ($show === 'true' ? '1' : '0')};
   border-radius: 8px;
   padding: 1rem 1.5rem 1.5rem 1.5rem;
   min-width: 500px;
   animation: ${({ $show }) => ($show === 'true' ? popUp : popDown)} 0.3s
      ease-in-out forwards;

   @media (max-width: 768px) {
      height: auto;
      max-height: 85vh;
      max-height: 85dvh;
      width: 100%;
      min-width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      border-radius: 18px 18px 0 0;
      padding: 0 1rem 0;
      animation: ${({ $show }) => ($show === 'true' ? slideInUp : slideOutDown)}
         0.28s cubic-bezier(0.22, 1, 0.36, 1) forwards;
      box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.18);
   }
`;

const MobileHandle = styled.div`
   display: none;
   @media (max-width: 768px) {
      display: block;
      width: 40px;
      height: 4px;
      background: ${colors.GRAY12};
      border-radius: 999px;
      margin: 8px auto 6px;
      cursor: pointer;
   }
`;

const ScrollBody = styled.div`
   @media (max-width: 768px) {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      flex: 1 1 auto;
      min-height: 0;
      padding-top: 4px;
      padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0px));
   }
`;

const HeadingWrapper = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 0 0 10px 0;
   border-bottom: 1px solid ${colors.GRAY13};
`;

const Heading = styled.p`
   font-size: 16px;
   font-weight: 600;
   color: ${colors.GRAY1};
`;

const CloseBtn = styled.div`
   width: 30px;
   height: 30px;
   display: grid;
   place-items: center;
   border-radius: 4px;
   cursor: pointer;
   &:hover {
      background: ${colors.GRAY14};
   }
`;

const slideInUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const slideOutDown = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;

const popUp = keyframes`
   0% {
     opacity: 0;
     transform: scale(0.6) translateY(20px);
   }
   50% {
     opacity: 1;
     transform: scale(1.05) translateY(0);
   }
   100% {
     transform: scale(1);
   }
 `;

const popDown = keyframes`
   0% {
     opacity: 1;
     transform: scale(1);
   }
   50% {
     transform: scale(1.05);
   }
   100% {
     opacity: 0;
     transform: scale(0.6) translateY(20px);
   }
 `;

export default _Placeholder;
